import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { GraphicsInfo } from "../../../../domain/graphics-info";
import { AutopilotRule } from "../../../../domain/rule";
import { GraphicsRepository } from "../../../../domain/graphics-repository";
import { MediaRepository } from "../../../../domain/media-repository";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "icn-autopilot-rule-wizard-step1-substep2",
  templateUrl: "./substep2.html",
  styleUrls: ["./substep2.scss"],
})
export class AutopilotRuleWizardStep1Substep2Component
  implements WizardSubstep, OnInit
{
  constructor(
    private _graphicsRepository: GraphicsRepository,
    private _mediaRepository: MediaRepository,
    private toastr: ToastrService,
  ) {}

  onDrag = false;

  @Input()
  rule: AutopilotRule;
  selectedDragItem: DragItemViewModel;

  async ngOnInit() {
    if (this.rule.graphicId) {
      const gfxInstance = await this._graphicsRepository.getGraphics(
        this.rule.graphicId,
      );
      this.selectedDragItem = new DragItemViewModel(
        gfxInstance.id,
        gfxInstance.name,
        gfxInstance.thumbnail,
        0,
      );
    } else if (this.rule.floatingMediaId) {
      const mediaItem = await this._mediaRepository.getMediaInfo(
        this.rule.floatingMediaId,
      );
      this.selectedDragItem = new DragItemViewModel(
        mediaItem.id,
        mediaItem.name,
        mediaItem.contentSnapshotUrl,
        1,
      );
    }
  }

  canGoNext() {
    return true;
  }

  onDragEnter() {
    this.onDrag = true;
  }

  onDragLeave() {
    this.onDrag = false;
  }

  onDrop(event: DragEvent) {
    let gfxItem = event.dataTransfer.getData("text/graphics");
    if (gfxItem) {
      const gfxInstance = JSON.parse(gfxItem);
      if (gfxInstance.isTemplate) {
        this.toastr.error(
          "Rule can use only graphic instances.",
          "TEMPLATES NOT ALLOWED",
        );
        return;
      }
      this.selectedDragItem = new DragItemViewModel(
        gfxInstance.id,
        gfxInstance.name,
        gfxInstance.thumbnail,
        0,
      );
      this.rule.graphicId = gfxInstance.id;
      this.rule.floatingMediaId = null;
    }
    const mediaItemJson = event.dataTransfer.getData("text/media");
    if (mediaItemJson) {
      const mediaItem = JSON.parse(mediaItemJson);
      this.selectedDragItem = new DragItemViewModel(
        mediaItem.id,
        mediaItem.name,
        mediaItem.contentSnapshotUrl,
        1,
      );
      this.rule.graphicId = null;
      this.rule.floatingMediaId = mediaItem.id;
    }

    this.onDrag = false;
  }

  onTrashClick() {
    this.selectedDragItem = undefined;
    this.rule.graphicId = null;
    this.rule.floatingMediaId = null;
  }
}
class DragItemViewModel {
  constructor(
    public id: number,
    public name: string,
    public thumbnail: string,
    public contentType: number,
  ) {}
}
